import React from 'react';
import { Flex, Spin } from 'antd';
import { SavedDateList } from '@/apis/logiblocksAPI';
import SavedListPanelShell from './SavedListPanelShell';
import LoadErrorNotice from './LoadErrorNotice';
import ListEditForm from './ListEditForm';
import { useSavedDateList } from './dateSetQueries';

interface ListEditPanelProps {
  listId: string;
  onBack: () => void;
  onUpdated: (list: SavedDateList) => void;
  onDeleted: () => void;
}

/** The pencil-icon edit surface for an existing saved list: loads the list,
 * then hands it to the edit form. */
const ListEditPanel: React.FC<ListEditPanelProps> = ({
  listId,
  onBack,
  onUpdated,
  onDeleted,
}) => {
  const { data: list, isError, refetch } = useSavedDateList(listId);

  if (list) {
    return (
      <ListEditForm
        key={list.id}
        list={list}
        onBack={onBack}
        onUpdated={onUpdated}
        onDeleted={onDeleted}
      />
    );
  }

  return (
    <SavedListPanelShell title='Edit list' onBack={onBack}>
      {isError ? (
        <LoadErrorNotice
          message="Couldn't load this list."
          onRetry={() => refetch()}
        />
      ) : (
        <Flex justify='center'>
          <Spin size='small' />
        </Flex>
      )}
    </SavedListPanelShell>
  );
};

export default ListEditPanel;
